import { styled } from '@linaria/react';

import Demo, { DemoSliderControl } from '@/components/Demo';
import InlineCode from '@/components/InlineCode';

function TheTrickDemo() {
  return (
    <Demo
      id="transform-rotate"
      initialValues={{
        offset: 0,
      }}
      controlPosition="top"
      customGrid={{
        gridTemplateColumns: 'min(450px, 100%)',
        justifyContent: 'center',
      }}
      controls={[
        <DemoSliderControl
          key="offset"
          id="offset"
          label="Offset"
          min={0}
          max={100}
        />,
      ]}
    >
      {({ offset }) => {
        const windowWidth =
          typeof window === 'undefined' ? 1024 : window.innerWidth;

        const width = Math.min(333, windowWidth * 0.75);
        const height = width * 1.5;

        return (
          <Wrapper>
            <HalfImage
              style={{
                backgroundImage: `url(/images/folding-the-dom/francois-hoang-china.jpg)`,
                backgroundSize: 'cover',
                borderRadius:
                  offset < 100 ? '0 0 0 0' : '10px 10px 0 0',
                transition: 'border-radius 400ms',
              }}
            />
            <HalfImage
              style={{
                backgroundImage: `url(/images/folding-the-dom/francois-hoang-china.jpg)`,
                backgroundSize: 'cover',
                backgroundPosition: `0 ${offset}%`,
                borderRadius:
                  offset < 100 ? '0 0 0 0' : '0 0 10px 10px',
                transform: `translateY(${offset < 100 ? 5 : 0}px)`,
                transition: 'transform 250ms, border-radius 400ms',
              }}
            />
            <Code>
              background-position: '0 {Math.round(offset)}%'
            </Code>
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const HalfImage = styled.div`
  width: min(343px, 75%);
  aspect-ratio: 3 / 2;
`;

const Code = styled(InlineCode)`
  && {
    font-size: 1.3125rem;
    position: relative;
    z-index: 2;
    margin-top: 32px;
  }
`;

export default TheTrickDemo;
